const state = {
    show: false,
    component: '',
    title: '',
    message: '',
    style: {}
}

const mutations = {
    setShow(state, val) {
        state.show = val
    },
    setComponent(state, val) {
        state.component = val
    },
    setTitle(state, val) {
        state.title = val
    },
    setMessage(state, val) {
        state.message = val
    },
    setStyle(state, val) {
        state.style = val
    }
}

const actions = {
    openModal({ commit }, { component, title, message, style }) {
        document.body.style.overflowY = 'hidden'
        commit('setShow', true)
        commit('setComponent', component)
        commit('setTitle', title)
        commit('setMessage', message)
        commit('setStyle', style)
    },
    closeModal({ commit }) {
        document.body.style.overflowY = 'scroll'
        commit('setShow', false)
        commit('setComponent', '')
        commit('setTitle', '')
        commit('setMessage', '')
        commit('setStyle', {})
    }
}

const getters = {
    show(state) {
        return state.show
    },
    component(state) {
        return state.component
    },
    title(state) {
        return state.title
    },
    message(state) {
        return state.message
    },
    style(state) {
        return state.style
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}